<template>
    <div class="meeting-edit">
        <HszdCard class="edit-content">
            <div v-if="activeKey == '会议记录'" class="record-wrap" ref="recordRef">
                <div class="audio-processing-status">
                    <div class="status-indicator">
                        <div class="status-text">正在处理音频文件...</div>
                    </div>
                </div>
                
                <div class="info-section">
                    <template v-for="item in meetingRecordTyping" :key="item.field">
                        <div class="record-block" :class="item.vertical ? 'is-vertical' : ''">
                            <div class="block-name">{{ item.text }}</div>
                            <div class="title" v-if="!isEditing">{{ meetingSummary[item.field] }}</div>
                            <template v-else>
                                <a-textarea v-if="item.component === 'textarea'"
                                    v-model:value="meetingSummary[item.field + '_new']" autoSize
                                    class="textarea"></a-textarea>
                                <a-input v-else v-model:value="meetingSummary[item.field + '_new']"
                                    class="title-input"></a-input>
                            </template>
                        </div>
                    </template>
                </div>
                
                <div class="meeting-content-section">
                    <div class="section-title">会议内容：</div>
                    <div class="mt-record-content" ref="recordContent">
                        <div v-for="(item, index) in meetingRecord" :key="index" class="record-item">
                            <div class="mt-record-header">
                                <span v-if="!isEditing" class="speaker">{{ item.speaker }}</span>
                                <a-select class="speaker" v-else v-model:value="item.speaker" style="width: 160px"
                                    :filter-option="false" :not-found-content="state.fetching ? undefined : null"
                                    :options="state.data">
                                    <template v-if="state.fetching" #notFoundContent>
                                        <a-spin size="small" />
                                    </template>
                                </a-select>
                                <span class="time">{{ item.time }}</span>
                                <a-button v-if="isEditing" type="primary" danger size="small"
                                    @click="handleSplit(index)">拆分</a-button>
                            </div>
                            <div class="content" v-if="!isEditing" v-html="item.content">
                            </div>
                            <div class="content editing-content" v-else v-html="item.content_new" contenteditable="true"
                                :data-content="item.content_new">
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- 用于在底部预留音频播放器空间的占位 -->
                <div class="audio-player-spacer"></div>
            </div>
            
            <div v-if="activeKey == '会议纪要'" class="summary-wrap" ref="recordRef">
                <template v-for="item in meetingSummaryTyping" :key="item.field">
                    <div class="record-block" :class="item.vertical ? 'is-vertical' : ''">
                        <div class="block-name">{{ item.text }}</div>
                        <div class="title" v-if="!isEditing">{{ meetingSummary[item.field] }}</div>
                        <template v-else>
                            <a-textarea v-if="item.component === 'textarea'"
                                v-model:value="meetingSummary[item.field + '_new']" autoSize
                                class="textarea"></a-textarea>
                            <a-input v-else v-model:value="meetingSummary[item.field + '_new']"
                                class="title-input"></a-input>
                        </template>
                    </div>
                </template>
                
                <!-- 用于在底部预留音频播放器空间的占位 -->
                <div class="audio-player-spacer"></div>
            </div>
        </HszdCard>
        
        <!-- 固定在底部的音频播放器 -->
        <div class="audio-player-container" v-show="activeKey == '会议记录'">
            <HszdAudio ref="audioRef" :source="audio_url" />
        </div>
    </div>
</template>
<script setup>

/* eslint-disable */
import { Modal, Spin } from 'ant-design-vue';
import { reactive, ref, onActivated, nextTick, h, computed } from 'vue';

import { useRouter } from 'vue-router'
import HszdCard from '@/components/hszdCard/HszdCard.vue';
import HszdAudio from '@/components/hszdAudio/HszdAudio.vue';
import {
    SaveOutlined,
    CloseCircleOutlined,
    EditOutlined,
    ReloadOutlined
} from '@ant-design/icons-vue';
import { BASE_URL } from '@/config/api';
const recordRef = ref();
const loading = ref(false);
const data = ref([]);
let lastFetchId = 0;
const router = useRouter()
const activeKey = ref('会议记录')
const formState = reactive({
    name: '',
    users: [],
    meettime: '',
});
const state = reactive({
    data: [],
    value: [],
    fetching: false,
});

const recordContent = ref()
const showPropsConfirm = () => {
    const modalIns = Modal.info({
        title: '提示',
        content: h('div', [
            h(Spin),
            h('span', {
                style: 'padding-left:20px'
            }, '加载中')
        ]),
        footer: null,
    });
    const timer = setInterval(() => {
        fetch(`${BASE_URL}/check_meeting_record_and_summary/${router.currentRoute.value.params.id}`)
            .then(response => response.json())
            .then(body => {
                console.log(body)
                if (body == true) {
                    clearInterval(timer)
                    modalIns.destroy()
                    get_meeting_summary()
                    get_meeting_record()
                }
            }).catch(() => { });
    }, 1000)

};
const isEditing = ref(false)
const audio_url = ref('')
// 会议记录
const meetingRecord = ref([

]);

const MAIN_SYMBLE = '%t'
const HARD_SYMBLE = '%h'
const formattedContent = (content, symble, symble2) => {
    const pattern = new RegExp(symble + '(.*?)' + symble, 'g')
    const pattern2 = new RegExp(symble2 + '(.*?)' + symble2, 'g')
    return content.replace(pattern, (match, p1) => {
        return `<span class="hidden">${symble}</span><span class="main-highlight">${p1}</span><span class="hidden">${symble}</span>`
    }).replace(pattern2, (match, p1) => {
        return `<span class="hidden">${symble2}</span><span class="hard-highlight">${p1}</span><span class="hidden">${symble2}</span>`
    })
}

const splitParams = {
    startContent: '',
    endContent: '',
}
const subscribeSplitEvent = () => {
    const domList = recordContent.value?.querySelectorAll('.editing-content')
    domList.forEach((item) => {
        item.addEventListener('mousedown', function () {
            const selection = window.getSelection();
            // 获取光标位置
            const editContent = item.textContent
            setTimeout(() => {
                const parentNode = selection.anchorNode.parentNode
                const isMain = parentNode.className == 'main-highlight'
                const isHard = parentNode.className == 'hard-highlight'
                const oIndex = editContent.indexOf(selection.anchorNode.nodeValue)

                const cursorPosition = oIndex + selection.anchorOffset
                // 获取光标前的文本
                let textBeforeCursor = editContent.substring(0, cursorPosition)
                // 获取光标后的文本
                let textAfterCursor = editContent.substring(cursorPosition)
                if (textBeforeCursor && textAfterCursor) {
                    // 如果分割的是特殊文字，需要收尾拼接特定符号
                    if (isMain) {
                        textBeforeCursor = textBeforeCursor + MAIN_SYMBLE
                        textAfterCursor = MAIN_SYMBLE + textAfterCursor
                    }
                    if (isHard) {
                        textBeforeCursor = textBeforeCursor + HARD_SYMBLE
                        textAfterCursor = HARD_SYMBLE + textAfterCursor
                    }
                    splitParams.startContent = textBeforeCursor
                    splitParams.endContent = textAfterCursor
                }
            }, 0)
        })

        item.addEventListener('mouseup', function () {
            const selection = window.getSelection();
            const editContent = item.innerText
            // 获取选中文本的起始和结束位置
            setTimeout(() => {
                const anchorIndex = editContent.indexOf(selection.anchorNode.nodeValue)
                const focusIndex = editContent.indexOf(selection.focusNode.nodeValue)

                const cursorPositionStart = anchorIndex + selection.anchorOffset
                const cursorPositionEnd = focusIndex + selection.focusOffset

                // 检查是否有文本被选中
                if (cursorPositionStart !== cursorPositionEnd) {
                    console.log('用户选中了文本')
                    console.log(editContent.substring(cursorPositionStart, cursorPositionEnd))
                }
            }, 0)

        })
    })
}
const handleSplit = (index) => {
    meetingRecord.value[index] = {
        ...meetingRecord.value[index],
        content: formattedContent(splitParams.startContent, MAIN_SYMBLE, HARD_SYMBLE),
        content_new: formattedContent(splitParams.startContent, MAIN_SYMBLE, HARD_SYMBLE),
    }
    meetingRecord.value.splice(index + 1, 0, {
        ...meetingRecord.value[index],
        content: formattedContent(splitParams.endContent, MAIN_SYMBLE, HARD_SYMBLE),
        content_new: formattedContent(splitParams.endContent, MAIN_SYMBLE, HARD_SYMBLE),
    })
}
meetingRecord.value = meetingRecord.value.map(item => ({
    ...item,
    content: formattedContent(item.content, MAIN_SYMBLE, HARD_SYMBLE)
}
))
// 会议记录标头字段
const meetingRecordTyping = [
    {
        text: '会议名称：',
        field: 'meeting_name'
    },
    {
        text: '会议时间：',
        field: 'datetime'
    },
    {
        text: '参会人员：',
        field: 'users',
    },
]
// 会议总结
const meetingSummary = ref({
    meeting_name: '',
    title: '',
    theme: '',
    datetime: '',
    users: '',
    content: '',
    words: ''
})

// 会议总结字段
const meetingSummaryTyping = [
    {
        text: '会议名称：',
        field: 'meeting_name'
    },
    {
        text: '会议时间：',
        field: 'datetime'
    },
    {
        text: '会议主题：',
        field: 'meeting_title'
    },
    {
        text: '会议关键词：',
        field: 'meeting_words',
    },
    {
        text: '参会人员：',
        field: 'users',
    },
    {
        text: '会议重点：',
        field: 'content',
        vertical: true,
        component: 'textarea'
    },
    {
        text: '会议计划',
        field: 'meeting_plan',
        vertical: true,
        component: 'textarea'
    }
]

// 获取最新的音频解析结果
const get_current_progress = () => {
    // reload_all
    // 获取会议记录 meetingrecord
    fetch(`${BASE_URL}/get_current_progress/${router.currentRoute.value.params.id}`)
        .then(response => response.json())
        .then(body => {
            console.log('body', body)
            // 如果识别没有完毕，继续轮询

            meetingRecord.value = body.total_res.map(item => ({
                id: item.id,
                time: '10:00',
                speaker: item.speaker,
                content: item.content,
            }));
            console.log('data', data.value)

            if (body.status == 2) {
                // 识别完毕，停止轮询 并跳转到会议记录页面
                router.push({ path: '/meetingedit/' + router.currentRoute.value.params.id });
            }

            if (body.status == 0) {
                setTimeout(() => {
                    get_current_progress()
                }, 1000)
            }
        }).catch(() => { });
}

const handleEdit = () => {
    meetingRecord.value.forEach(record => {
        Object.keys(record).forEach(key => {
            record[key + '_new'] = record[key]
        })
    })
    Object.keys(meetingSummary.value).forEach(key => {
        meetingSummary.value[key + '_new'] = meetingSummary.value[key]
    })
    isEditing.value = true
    nextTick(() => {
        const input = recordRef.value.querySelector('input')
        input.focus()
        subscribeSplitEvent()
    })
}
const handleSave = () => {
    if (activeKey.value == '会议记录') {
        const newRecords = meetingRecord.value.map(record => {
            const newRecord = {}
            Object.keys(record).filter(key => key.includes('_new')).forEach(key => {
                newRecord[key.replace('_new', '')] = record[key];
            });
            return newRecord
        })
        console.log(newRecords);
    } else {
        const newSummary = {};
        Object.keys(meetingSummary.value).filter(key => key.includes('_new')).forEach(key => {
            newSummary[key.replace('_new', '')] = meetingSummary.value[key];
        });
        console.log(newSummary);
    }
    // TODO 保存接口

    isEditing.value = false
}

const myPermission = computed(() => {
    const permission = localStorage.getItem('myPermission') || '{}'
    return JSON.parse(permission)
})

onActivated(() => {

    // 清除之前的缓存数据
    meetingRecord.value = []
    meetingSummary.value = {}
    

    get_meeting_summary()
    isEditing.value = false
    lastFetchId += 1;
    const fetchId = lastFetchId;
    state.data = [];
    state.fetching = true;
    fetch(`${BASE_URL}/user?active_id=${myPermission.value.id}`)
        .then(response => response.json())
        .then(body => {
            if (fetchId !== lastFetchId) {
                // for fetch callback order
                return;
            }
            console.log('body', body)
            const data = body.items.map(user => ({
                label: user.name,
                value: user.id,
            }));
            state.data = data;
            state.fetching = false;

            // 初始数据加载
            console.log('初始数据加载')
            fetchData();
        }).catch(() => { });

    // 获取最新的音频解析记录进度
    get_current_progress()
    // 获取音频路径
    get_meeting_audio()
})

// 获取音频路径
const get_meeting_audio = async () => {
    const response = await fetch(`${BASE_URL}/meetings_path/${router.currentRoute.value.params.id}`).catch(() => { });
    if (!response) return
    const res = await response.json()
    console.log(res)
    audio_url.value = res.audio_url
};

const get_meeting_summary = async () => {
    const response = await fetch(`${BASE_URL}/show_meeting/${router.currentRoute.value.params.id}`).catch(() => { });
    if (!response) return
    const res = await response.json()
    let data = res

    console.log('data1', data)

    meetingSummary.value.meeting_title = data.meeting_title
    meetingSummary.value.meeting_words = data.meeting_words
    meetingSummary.value.meeting_name = data.meeting_name
    // 2024-10-13T15:12:37.859404 格式化为正常 .859404也不要 T 换成空格
    meetingSummary.value.datetime = data.meeting_date?.replace('T', ' ').split('.')[0]; // 去掉毫秒部分
    // meetingSummary.value.datetime = data.meeting_date
    meetingSummary.value.users = data.users
    meetingSummary.value.content = data.meeting_content
    meetingSummary.value.meeting_plan = data.meeting_plan
};

const get_meeting_record = async () => {
    const response = await fetch(`${BASE_URL}/meetingrecord/${router.currentRoute.value.params.id}`).catch(() => { });
    if (!response) return
    const res = await response.json()
    let data = res

    console.log('data2', data)

    meetingRecord.value = data.map(item => ({
        speaker: item.speaker,
        time: item.time,
        content: item.content,
    }));
};

const fetchData = async () => {
    loading.value = true;
    let id = router.currentRoute.value.params.id
    fetch(`${BASE_URL}/meeting/${id}`)
        .then(response => response.json())
        .then(data => {
            console.log('data', data)
            // data.speaker = 1,2 变成数组
            let userlist = data.speaker.includes(',') ? data.speaker.split(',') : [data.speaker];

            if (data.speaker == "") {
                userlist = []
                formState.users = []
            } else {
                // 遍历 userlist 并结合 state.data的数据 获得 label和value数组
                const selectedUsers = userlist.map(userName => {
                    const user = state.data.find(item => item.label === userName);
                    console.log('user', user)
                    return {
                        label: user.label,
                        value: user.value
                    };
                });
                formState.users = selectedUsers;
            }

            // 
            console.log('formState.users', [data.speaker])
            formState.name = data.title
            formState.meettime = '立刻开始'
            loading.value = false;
        }).catch(() => { });
};


</script>

<style scoped lang="less">
.meeting-edit {
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
}

.edit-content {
    height: 100%;
    padding: 0 !important;
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    flex: 1;
}

.audio-processing-status {
    padding: 15px 20px;
    background-color: #f0f7ff;
    border-bottom: 1px solid #d9e8ff;
    
    .status-indicator {
        display: flex;
        align-items: center;
        
        &::before {
            content: '';
            display: inline-block;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background-color: #1890ff;
            margin-right: 8px;
            animation: pulse 1.5s infinite ease-in-out;
        }
        
        .status-text {
            font-weight: 500;
            color: #1890ff;
        }
    }
}

@keyframes pulse {
    0% {
        opacity: 0.5;
        transform: scale(0.8);
    }
    50% {
        opacity: 1;
        transform: scale(1.2);
    }
    100% {
        opacity: 0.5;
        transform: scale(0.8);
    }
}

.info-section {
    padding: 15px 20px;
    background-color: #f9f9f9;
    border-bottom: 1px solid #eaeaea;
    flex-shrink: 0;
}

.meeting-content-section {
    padding: 15px 20px;
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0; /* 这是关键，确保flex容器可以正确压缩 */
    
    .section-title {
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 10px;
        color: #333;
        flex-shrink: 0;
    }
}

.mt-record-content {
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    padding: 10px;
    overflow-y: auto;
    flex: 1;
    
    .record-item {
        margin-bottom: 15px;
        border-bottom: 1px dashed #eaeaea;
        padding-bottom: 10px;
        
        &:last-child {
            border-bottom: none;
        }
    }

    .mt-record-header {
        position: relative;
        padding: 0 10px;
        display: flex;
        align-items: center;
        margin-bottom: 5px;
    }

    .mt-record-header::before {
        content: '';
        position: absolute;
        left: 2px;
        top: 50%;
        margin-top: -4px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #1F5BC3;
        box-shadow: 0px 1px 3px 0px rgba(0, 94, 255, 0.4);
    }

    .speaker {
        color: #555;
        margin: 0 12px;
        position: relative;
        line-height: 36px;
        font-weight: 500;
        display: inline-block;
    }

    .time {
        color: #888;
        margin-right: 10px;
        font-weight: 400;
    }

    .content {
        min-height: 40px;
        padding: 10px 15px;
        font-weight: 400;
        line-height: 1.6;
        background-color: #f9f9f9;
        border-radius: 6px;

        :deep(.hidden) {
            display: none;
        }

        :deep(.main-highlight) {
            background-color: #4285f4;
            color: white;
            padding: 0 3px;
            border-radius: 3px;
        }

        :deep(.hard-highlight) {
            background-color: #34a853;
            color: white;
            padding: 0 3px;
            border-radius: 3px;
        }
    }

    .editing-content {
        min-height: 40px;
        padding: 10px 15px;
        font-weight: 400;
        line-height: 1.6;
        overflow: auto;
        white-space: pre-wrap;
        cursor: text;
        user-select: text;
        box-shadow: var(--input-shadow);
        border: 1px solid #D9D9D9;
        border-radius: 6px;
        background-color: #fff;

        &:focus-visible {
            outline-offset: 0px;
            outline: 1px;
            border-color: #427acf;
            border-inline-end-width: 1px;
        }

        :deep(.hidden) {
            display: none;
        }

        :deep(.main-highlight) {
            background-color: #4285f4;
            color: white;
            padding: 0 3px;
            border-radius: 3px;
        }

        :deep(.hard-highlight) {
            background-color: #34a853;
            color: white;
            padding: 0 3px;
            border-radius: 3px;
        }
    }
}

.audio-player-container {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #f9f9f9;
    border-top: 1px solid #eaeaea;
    padding: 15px 20px;
    z-index: 100;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

.audio-player-spacer {
    height: 80px; /* 与音频播放器高度一致，用于占位 */
    flex-shrink: 0;
}

.record-wrap {
    display: flex;
    flex-direction: column;
    font-weight: 500;
    height: 100%;
    overflow: hidden;
}

.record-block {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.record-block .block-name {
    line-height: 35px;
    width: 90px;
    color: #555;
}

.record-block .title {
    padding: 0 11px;
    color: #333;
}

.record-block.is-vertical {
    display: block;
    margin-top: 20px;
}

.record-block.is-vertical .block-name {
    width: auto;
    margin-bottom: 5px;
}

.record-block.is-vertical .title {
    line-height: 1.5;
    min-height: 35px;
    padding: 12px;
    background-color: #f9f9f9;
    border-radius: 6px;
}

.record-block .title-input {
    flex: 1;
    filter: none;
    border-radius: 4px;
    box-shadow: none;
}

.summary-wrap {
    padding: 20px;
    height: 100%;
    font-weight: 500;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
}

.textarea {
    background-color: #fff;
    border-radius: 6px;
}
</style>